import {
  PapiGruserModuleExhibitionistConfig,
  PapiPremiumFolderData,
} from '@wix/da-papi-types';

export enum ExhibitionistWidgetType {
  TALL = 'tall',
  STRIP = 'strip',
}

export type ExhibitionistModuleConfig = PapiGruserModuleExhibitionistConfig;
export type ExhibitionistModuleOptions = ExhibitionistModuleConfig['options'];
export type ExhibitionistModuleGalleryListItem = Unpacked<
  ExhibitionistModuleOptions['galleryList']
>;
export type ExhibitionistModuleCollectionListItem = Unpacked<
  ExhibitionistModuleOptions['collectionList']
>;
export type ExhibitionistModuleSourceTypeOptions =
  ExhibitionistModuleOptions['sourceTypes'];
export type ExhibitionistModuleFolderList = Pick<
  ExhibitionistModuleOptions,
  'galleryList' | 'collectionList'
>;
export type ExhibitionistPremiumFolderData = NonNullable<PapiPremiumFolderData>;

export enum ExhibitionistViewMode {
  TORPEDO = 'torpedo',
  SLIDESHOW = 'slideshow',
}

export enum ExhibitionistSlideFitMode {
  FIT = 'fit',
  COVER = 'cover',
}

export enum GallectionSourceType {
  FEATURED_GALLERY = 'featured_gallery',
  NEWEST = 'newest',
  GALLERY = 'gallery',
  COLLECTION = 'collection',
  PRIVATE_COLLECTION = 'private_collection',
  ADOPTABLE_BOUGHT = 'adoptable_bought',
  ADOPTABLE_FOR_SALE = 'adoptable_for_sale',
}

export enum GallectionSortOrder {
  NEWEST = 'newest',
  POPULAR = 'popular',
}
